/**
 * Deterministic hash-based pseudo-noise (no interpolation) — enough for
 * displacing low-poly procedural geometry (rocks, sand edges, fronds)
 * without pulling in a full noise library. Not smooth/coherent noise; on
 * low-subdivision meshes that's a feature (it reinforces the faceted,
 * hard-edged look the art direction calls for), not a bug.
 */
export function hashNoise(x: number, y: number): number {
  const v = Math.sin(x * 12.9898 + y * 78.233) * 43758.5453;
  return (v - Math.floor(v)) * 2 - 1; // -1..1
}
